import React from 'react'
import { useHistory } from 'react-router-dom'
import { Controller, FormContext, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Box, Button, TextField } from '@material-ui/core'

import { FileUploadInput, Select } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import theme from 'theme'
import schema from './schema'
import * as service from 'service'
import constants from 'constants/index'

const SolicitationForm = ({ category, setLoading }) => {
  const { SOLICITATION_ITEMS, SOLICITATION_OTHERS_ID } = constants.faqs

  const history = useHistory()
  const snackbar = useSnackbar()
  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      category: category || SOLICITATION_OTHERS_ID,
      title: '',
      description: '',
      files: undefined,
    },
  })

  const { control, errors, handleSubmit, reset } = formMethods

  const handleGoBack = () => history.goBack()

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.tomticketIntermediator.createTicket(data)

      snackbar.open({
        message: 'Ticket enviado com sucesso!',
        variant: 'success',
      })
      reset()
      handleGoBack()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error.response.data.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormContext {...formMethods}>
      <Box
        component="form"
        id="solicitation-form"
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Controller
          control={control}
          name="category"
          as={
            <Select
              items={SOLICITATION_ITEMS}
              label="Tipo de atendimento"
              error={!!errors?.category}
              helperText={errors?.category?.message}
            />
          }
        />
        <Controller
          control={control}
          name="title"
          as={
            <TextField
              label="Título"
              error={!!errors?.title}
              helperText={errors?.title?.message}
              fullWidth
            />
          }
        />
        <Controller
          control={control}
          name="description"
          as={
            <TextField
              label="Descrição"
              error={!!errors?.description}
              helperText={errors?.description?.message}
              placeholder="Descreva detalhadamente o motivo do seu contato."
              multiline
              minRows={10}
              maxRows={10}
              fullWidth
            />
          }
        />
        <Controller
          control={control}
          name="files"
          as={
            <FileUploadInput
              controlName="files"
              hasDownloadFile
              controllerBar
              multiple
            />
          }
        />
        <Box
          display="flex"
          gridGap={theme.spacing(1)}
          justifyContent="flex-end"
        >
          <Button variant="outlined" color="primary" onClick={handleGoBack}>
            Voltar
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            form="solicitation-form"
          >
            Solicitar atendimento
          </Button>
        </Box>
      </Box>
    </FormContext>
  )
}

SolicitationForm.propTypes = {
  category: PropTypes.string,
  setLoading: PropTypes.func.isRequired,
}

export default SolicitationForm
